import _ from 'underscore'
import INotification, {STATES} from "../../model/interface/ui/INotification";
import {IAppState} from "../store";

export const findAll = (store: IAppState) => store.streamEvents.notifications

export const findBy = (store: IAppState, property: string, value: any, limit?: number): INotification[] => _.where(findAll(store), {[property]: value}).slice(0, limit)

export const findOneBy = (store: IAppState, property: string, value: any): undefined|INotification => _.findWhere(findAll(store), {[property]: value})

export const findOneById = (store: IAppState, id: number): undefined|INotification => findOneBy(store, 'id', id)

export const findNotDeleted = (store: IAppState, limit?: number): INotification[] => findAll(store).filter((notification: INotification) => notification.state !== STATES.STATE_DELETED).slice(0, limit)

export const findUnread = (store: IAppState, limit?: number): INotification[] => findBy(store, 'state', STATES.STATE_NEW, limit)

export const countBy = (store: IAppState, property: string, value: any): number => findBy(store, property, value).length

export const countUnread = (store: IAppState): number => findUnread(store).length

const all = {
    findAll,
    findBy,
    findUnread,
    findOneBy,
    findOneById,
    findNotDeleted,
    countBy,
    countUnread
}
export default all